import classNames from "./components-careerum";

export default function(editor: any, opt: any = {}) {
	const domc = editor.DomComponents;
	const defaultType = domc.getType('default');
	const defaultModel = defaultType.model;

	const defaults = Object.assign({}, defaultModel.prototype.defaults, {
		traits: [
			{
				name: 'id'
			},
			{
				label: 'Якорь',
				name: 'custom-link-anchor',
				type: 'custom-anchor'
			}
		],
		attributes: {
			'custom-anchor': ''
		}
	});

	const injectableComponents = [
		'carrerum-question-with-social',
		'carrerum-question-with-social-tablet',
		'carrerum-question-with-social-mobile',
	];

	const droppableSelector = '[data-gjs-type="wrapper"]';

	const addTypeFromClassName = (className: string | string[]) => {
		if (Array.isArray(className)) {
			className.forEach(addTypeFromClassName);
			return;
		}

		let droppable = injectableComponents.indexOf(className) == -1 ? droppableSelector : '*';

		domc.addType(className, {
			model: defaultModel.extend({
				defaults: {
				...defaults,
				droppable: droppable,
				draggable: droppable
				}
			}, {
				isComponent(el: HTMLElement) {
					if(el.tagName === 'DIV' && el.classList.contains(className)){
						return {type: className};
					}
				},
			}),
		});
	};

	return addTypeFromClassName;
}